import registerTask from '../../../common/tasks/index';
import presentationalComponent from './TaskPresentationalWrapper';
import containerComponent from './TaskContainer';
import platformSingleton from '../../platform/platformSingleton';
import { isDesktopMode } from '../../platform/utils/platformDetailsUtils';

import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbar/config/toolbarToolConfig';
import { labelsFeaturePredicate } from '../labels/labelsUtils';

const DESKTOP_EDITING_TOOLS = [
    TOOLBAR_TOOLS.COLOR,
    TOOLBAR_TOOLS.TITLE,
    TOOLBAR_TOOLS.DUE_DATE,
    TOOLBAR_TOOLS.ASSIGNMENT,
    TOOLBAR_TOOLS.REACTION,
    { ...TOOLBAR_TOOLS.LABEL, availabilityPredicate: labelsFeaturePredicate },
    TOOLBAR_TOOLS.COMMENT,
    TOOLBAR_TOOLS.INDENT_INCREASE,
    TOOLBAR_TOOLS.INDENT_DECREASE,
];

const MOBILE_EDITING_TOOLS = [
    TOOLBAR_TOOLS.COLOR,
    TOOLBAR_TOOLS.TITLE,
    TOOLBAR_TOOLS.DUE_DATE,
    TOOLBAR_TOOLS.ASSIGNMENT,
    TOOLBAR_TOOLS.INDENT_INCREASE,
    TOOLBAR_TOOLS.INDENT_DECREASE,
    TOOLBAR_TOOLS.REACTION,
    { ...TOOLBAR_TOOLS.LABEL, availabilityPredicate: labelsFeaturePredicate },
    TOOLBAR_TOOLS.COMMENT,
];

export default () =>
    registerTask({
        containerComponent,
        presentationalComponent,
        tools: {
            editing: isDesktopMode(platformSingleton) ? DESKTOP_EDITING_TOOLS : MOBILE_EDITING_TOOLS,
            editingRange: TOOL_SETS.TEXT_EDITING_INLINE,
        },
    });
